enum paymentEndPoints {
  REVENUE_COUNTS = '/admin-revenue/counts',
  RECENT_TRANSACTIONS = '/admin-revenue/recent-transactions',
  REVENUE = '/admin-revenue',
  REVENUE_SUMMARY = '/admin-revenue/summary',
  WITHDRAWN = '/payment/withdrawn-history',
}
export default paymentEndPoints;
